export default "__VITE_ASSET__CRLdDZIf__"